import {
  START_REQUEST,
  STOP_REQUEST,
  FETCH_TASKS_SUCCESS,
  FETCH_SCHEDULED_TASKS_SUCCESS,
  UPDATE_TASK_SUCCESS,
  FETCH_TASKS_REQUEST,
  FETCH_TASKS_FAILURE,
  FETCH_SCHEDULED_TASKS_REQUEST,
  FETCH_SCHEDULED_TASKS_FAILURE
} from '../actions/tasksActions';

export default (state = { tasks: [], hasMoreTasks: false, scheduledTasks: [], hasMoreScheduledTasks: false, loading: false }, action) => {
  switch (action.type) {
  case START_REQUEST: {
    return {
      ...state,
      loading: true,
    };
  }
  case STOP_REQUEST: {
    return {
      ...state,
      loading: false,
    };
  }
  case FETCH_TASKS_REQUEST: {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }
  case FETCH_TASKS_SUCCESS: {
    return {
      ...state,
      tasks: action.payload.tasks,
      hasMoreTasks: action.payload.has_more,
      loading: false,
      error: null,
    };
  }
  case FETCH_TASKS_FAILURE: {
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
  }
  case UPDATE_TASK_SUCCESS: {
    const { taskId, updates } = action.payload;
    return {
      ...state,
      tasks: state.tasks.map(task => {
        if (task.id === taskId) {
          return {
            ...task,
            metadata: {
              ...task.metadata,
              ...updates,
            },
          };
        }
        return task;
      }),
    };
  }
  case FETCH_SCHEDULED_TASKS_REQUEST: {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }
  case FETCH_SCHEDULED_TASKS_SUCCESS: {
    return {
      ...state,
      scheduledTasks: action.payload.tasks,
      hasMoreScheduledTasks: action.payload.has_more,
      loading: false,
      error: null,
    };
  }
  case FETCH_SCHEDULED_TASKS_FAILURE: {
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
  }
  default:
    return state;
  }
};
